export default __webpack_public_path__ + "6fd7894b75ccede102c9f6f989e02ac6.svg";